// AI Generated File
import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { PrimeNG } from 'primeng/config';

@Injectable({
    providedIn: 'root',
})
export class PrimeNGTranslationService {
    private readonly translocoService = inject(TranslocoService);
    private readonly primeNG = inject(PrimeNG);

    constructor () {
        this.updateTranslations();
        this.translocoService.langChanges$.subscribe(() => {
            this.updateTranslations();
        });
    }

    private updateTranslations (): void {
        this.primeNG.setTranslation({
            // DataTable and filtering translations
            startsWith: this.translocoService.translate('primeng.startsWith'),
            contains: this.translocoService.translate('primeng.contains'),
            notContains: this.translocoService.translate('primeng.notContains'),
            endsWith: this.translocoService.translate('primeng.endsWith'),
            equals: this.translocoService.translate('primeng.equals'),
            notEquals: this.translocoService.translate('primeng.notEquals'),
            noFilter: this.translocoService.translate('primeng.noFilter'),
            lt: this.translocoService.translate('primeng.lt'),
            lte: this.translocoService.translate('primeng.lte'),
            gt: this.translocoService.translate('primeng.gt'),
            gte: this.translocoService.translate('primeng.gte'),
            is: this.translocoService.translate('primeng.is'),
            isNot: this.translocoService.translate('primeng.isNot'),
            before: this.translocoService.translate('primeng.before'),
            after: this.translocoService.translate('primeng.after'),
            dateIs: this.translocoService.translate('primeng.dateIs'),
            dateIsNot: this.translocoService.translate('primeng.dateIsNot'),
            dateBefore: this.translocoService.translate('primeng.dateBefore'),
            dateAfter: this.translocoService.translate('primeng.dateAfter'),
            clear: this.translocoService.translate('primeng.clear'),
            apply: this.translocoService.translate('primeng.apply'),
            matchAll: this.translocoService.translate('primeng.matchAll'),
            matchAny: this.translocoService.translate('primeng.matchAny'),
            addRule: this.translocoService.translate('primeng.addRule'),
            removeRule: this.translocoService.translate('primeng.removeRule'),
            accept: this.translocoService.translate('primeng.accept'),
            reject: this.translocoService.translate('primeng.reject'),
            choose: this.translocoService.translate('primeng.choose'),
            upload: this.translocoService.translate('primeng.upload'),
            cancel: this.translocoService.translate('primeng.cancel'),
            pending: this.translocoService.translate('primeng.pending'),

            // File upload translations
            fileChosenMessage: this.translocoService.translate('primeng.fileChosenMessage'),
            noFileChosenMessage: this.translocoService.translate('primeng.noFileChosenMessage'),

            // Calendar translations
            dayNames: [
                this.translocoService.translate('primeng.dayNames.0'),
                this.translocoService.translate('primeng.dayNames.1'),
                this.translocoService.translate('primeng.dayNames.2'),
                this.translocoService.translate('primeng.dayNames.3'),
                this.translocoService.translate('primeng.dayNames.4'),
                this.translocoService.translate('primeng.dayNames.5'),
                this.translocoService.translate('primeng.dayNames.6'),
            ],
            dayNamesShort: [
                this.translocoService.translate('primeng.dayNamesShort.0'),
                this.translocoService.translate('primeng.dayNamesShort.1'),
                this.translocoService.translate('primeng.dayNamesShort.2'),
                this.translocoService.translate('primeng.dayNamesShort.3'),
                this.translocoService.translate('primeng.dayNamesShort.4'),
                this.translocoService.translate('primeng.dayNamesShort.5'),
                this.translocoService.translate('primeng.dayNamesShort.6'),
            ],
            dayNamesMin: [
                this.translocoService.translate('primeng.dayNamesMin.0'),
                this.translocoService.translate('primeng.dayNamesMin.1'),
                this.translocoService.translate('primeng.dayNamesMin.2'),
                this.translocoService.translate('primeng.dayNamesMin.3'),
                this.translocoService.translate('primeng.dayNamesMin.4'),
                this.translocoService.translate('primeng.dayNamesMin.5'),
                this.translocoService.translate('primeng.dayNamesMin.6'),
            ],
            monthNames: [
                this.translocoService.translate('primeng.monthNames.0'),
                this.translocoService.translate('primeng.monthNames.1'),
                this.translocoService.translate('primeng.monthNames.2'),
                this.translocoService.translate('primeng.monthNames.3'),
                this.translocoService.translate('primeng.monthNames.4'),
                this.translocoService.translate('primeng.monthNames.5'),
                this.translocoService.translate('primeng.monthNames.6'),
                this.translocoService.translate('primeng.monthNames.7'),
                this.translocoService.translate('primeng.monthNames.8'),
                this.translocoService.translate('primeng.monthNames.9'),
                this.translocoService.translate('primeng.monthNames.10'),
                this.translocoService.translate('primeng.monthNames.11'),
            ],
            monthNamesShort: [
                this.translocoService.translate('primeng.monthNamesShort.0'),
                this.translocoService.translate('primeng.monthNamesShort.1'),
                this.translocoService.translate('primeng.monthNamesShort.2'),
                this.translocoService.translate('primeng.monthNamesShort.3'),
                this.translocoService.translate('primeng.monthNamesShort.4'),
                this.translocoService.translate('primeng.monthNamesShort.5'),
                this.translocoService.translate('primeng.monthNamesShort.6'),
                this.translocoService.translate('primeng.monthNamesShort.7'),
                this.translocoService.translate('primeng.monthNamesShort.8'),
                this.translocoService.translate('primeng.monthNamesShort.9'),
                this.translocoService.translate('primeng.monthNamesShort.10'),
                this.translocoService.translate('primeng.monthNamesShort.11'),
            ],

            // Calendar navigation translations
            chooseYear: this.translocoService.translate('primeng.chooseYear'),
            chooseMonth: this.translocoService.translate('primeng.chooseMonth'),
            chooseDate: this.translocoService.translate('primeng.chooseDate'),
            prevDecade: this.translocoService.translate('primeng.prevDecade'),
            nextDecade: this.translocoService.translate('primeng.nextDecade'),
            prevYear: this.translocoService.translate('primeng.prevYear'),
            nextYear: this.translocoService.translate('primeng.nextYear'),
            prevMonth: this.translocoService.translate('primeng.prevMonth'),
            nextMonth: this.translocoService.translate('primeng.nextMonth'),
            prevHour: this.translocoService.translate('primeng.prevHour'),
            nextHour: this.translocoService.translate('primeng.nextHour'),
            prevMinute: this.translocoService.translate('primeng.prevMinute'),
            nextMinute: this.translocoService.translate('primeng.nextMinute'),
            prevSecond: this.translocoService.translate('primeng.prevSecond'),
            nextSecond: this.translocoService.translate('primeng.nextSecond'),
            am: this.translocoService.translate('primeng.am'),
            pm: this.translocoService.translate('primeng.pm'),
            today: this.translocoService.translate('primeng.today'),
            weekHeader: this.translocoService.translate('primeng.weekHeader'),
            firstDayOfWeek: this.translocoService.translate('primeng.firstDayOfWeek'),
            dateFormat: this.translocoService.translate('primeng.dateFormat'),

            // Password strength translations
            weak: this.translocoService.translate('primeng.weak'),
            medium: this.translocoService.translate('primeng.medium'),
            strong: this.translocoService.translate('primeng.strong'),
            passwordPrompt: this.translocoService.translate('primeng.passwordPrompt'),

            // Common messages
            emptyMessage: this.translocoService.translate('primeng.emptyMessage'),
            emptyFilterMessage: this.translocoService.translate('primeng.emptyFilterMessage'),
            searchMessage: this.translocoService.translate('primeng.searchMessage'),
            selectionMessage: this.translocoService.translate('primeng.selectionMessage'),
            emptySelectionMessage: this.translocoService.translate('primeng.emptySelectionMessage'),
            emptySearchMessage: this.translocoService.translate('primeng.emptySearchMessage'),

            // File size types
            fileSizeTypes: [
                this.translocoService.translate('primeng.fileSizeTypes.0'),
                this.translocoService.translate('primeng.fileSizeTypes.1'),
                this.translocoService.translate('primeng.fileSizeTypes.2'),
                this.translocoService.translate('primeng.fileSizeTypes.3'),
                this.translocoService.translate('primeng.fileSizeTypes.4'),
                this.translocoService.translate('primeng.fileSizeTypes.5'),
                this.translocoService.translate('primeng.fileSizeTypes.6'),
                this.translocoService.translate('primeng.fileSizeTypes.7'),
                this.translocoService.translate('primeng.fileSizeTypes.8'),
            ],

            // Accessibility (ARIA) translations
            aria: {
                trueLabel: this.translocoService.translate('primeng.aria.trueLabel'),
                falseLabel: this.translocoService.translate('primeng.aria.falseLabel'),
                nullLabel: this.translocoService.translate('primeng.aria.nullLabel'),
                star: this.translocoService.translate('primeng.aria.star'),
                stars: this.translocoService.translate('primeng.aria.stars'),
                selectAll: this.translocoService.translate('primeng.aria.selectAll'),
                unselectAll: this.translocoService.translate('primeng.aria.unselectAll'),
                close: this.translocoService.translate('primeng.aria.close'),
                previous: this.translocoService.translate('primeng.aria.previous'),
                next: this.translocoService.translate('primeng.aria.next'),
                navigation: this.translocoService.translate('primeng.aria.navigation'),
                scrollTop: this.translocoService.translate('primeng.aria.scrollTop'),
                moveTop: this.translocoService.translate('primeng.aria.moveTop'),
                moveUp: this.translocoService.translate('primeng.aria.moveUp'),
                moveDown: this.translocoService.translate('primeng.aria.moveDown'),
                moveBottom: this.translocoService.translate('primeng.aria.moveBottom'),
                moveToTarget: this.translocoService.translate('primeng.aria.moveToTarget'),
                moveToSource: this.translocoService.translate('primeng.aria.moveToSource'),
                moveAllToTarget: this.translocoService.translate('primeng.aria.moveAllToTarget'),
                moveAllToSource: this.translocoService.translate('primeng.aria.moveAllToSource'),
                pageLabel: this.translocoService.translate('primeng.aria.pageLabel'),
                firstPageLabel: this.translocoService.translate('primeng.aria.firstPageLabel'),
                lastPageLabel: this.translocoService.translate('primeng.aria.lastPageLabel'),
                nextPageLabel: this.translocoService.translate('primeng.aria.nextPageLabel'),
                prevPageLabel: this.translocoService.translate('primeng.aria.prevPageLabel'),
                rowsPerPageLabel: this.translocoService.translate('primeng.aria.rowsPerPageLabel'),
                previousPageLabel: this.translocoService.translate('primeng.aria.previousPageLabel'),
                jumpToPageDropdownLabel: this.translocoService.translate('primeng.aria.jumpToPageDropdownLabel'),
                jumpToPageInputLabel: this.translocoService.translate('primeng.aria.jumpToPageInputLabel'),
                selectRow: this.translocoService.translate('primeng.aria.selectRow'),
                unselectRow: this.translocoService.translate('primeng.aria.unselectRow'),
                expandRow: this.translocoService.translate('primeng.aria.expandRow'),
                collapseRow: this.translocoService.translate('primeng.aria.collapseRow'),
                showFilterMenu: this.translocoService.translate('primeng.aria.showFilterMenu'),
                hideFilterMenu: this.translocoService.translate('primeng.aria.hideFilterMenu'),
                filterOperator: this.translocoService.translate('primeng.aria.filterOperator'),
                filterConstraint: this.translocoService.translate('primeng.aria.filterConstraint'),
                editRow: this.translocoService.translate('primeng.aria.editRow'),
                saveEdit: this.translocoService.translate('primeng.aria.saveEdit'),
                cancelEdit: this.translocoService.translate('primeng.aria.cancelEdit'),
                listView: this.translocoService.translate('primeng.aria.listView'),
                gridView: this.translocoService.translate('primeng.aria.gridView'),
                slide: this.translocoService.translate('primeng.aria.slide'),
                slideNumber: this.translocoService.translate('primeng.aria.slideNumber'),
                zoomImage: this.translocoService.translate('primeng.aria.zoomImage'),
                zoomIn: this.translocoService.translate('primeng.aria.zoomIn'),
                zoomOut: this.translocoService.translate('primeng.aria.zoomOut'),
                rotateRight: this.translocoService.translate('primeng.aria.rotateRight'),
                rotateLeft: this.translocoService.translate('primeng.aria.rotateLeft'),
                listLabel: this.translocoService.translate('primeng.aria.listLabel'),
                selectColor: this.translocoService.translate('primeng.aria.selectColor'),
                removeLabel: this.translocoService.translate('primeng.aria.removeLabel'),
                browseFiles: this.translocoService.translate('primeng.aria.browseFiles'),
                maximizeLabel: this.translocoService.translate('primeng.aria.maximizeLabel'),
            },
        });
    }
}
